import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClaimGuard, FeatureFlagGuard, PayLaterGuard } from '@lsq-frontend/common-ui';
import { Routes } from '@lsq-frontend/common-ui';
import {
    supplyChainDirectBuyerAtlas,
    supplyChainDirectBuyerInsightsAtlas,
    supplyChainDirectBuyerInsightsNode,
    supplyChainDirectBuyerNode
} from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { SupplierDetailsComponent } from '../../buyer-account/suppliers/supplier-details/supplier-details.component';
import { AccountInvoicesComponent } from '../../buyer-account/invoices/invoices.component';
import { BuyerInsightsEarlyPayAdoptionComponent } from './insights/early-pay-adoption.component';
import { BuyerInsightsComponent } from './insights/insights.component';
import { BuyerInsightsGuard } from './insights/insights.guard';
import { BuyerInsightsSpendVolumeComponent } from './insights/spend-volume.component';
import { BuyerInsightsSupplierEnrollmentComponent } from './insights/supplier-enrollment.component';
import { BuyerInsightsWorkingCapitalLiftComponent } from './insights/working-capital-lift.component';
import { AccountPaymentDetailComponent } from '../payment-details/payment-detail.component';
import { SupplyChainDirectBuyerComponent } from './supply-chain-direct-buyer.component';
import { AccountParentGroupedInvoiceDetailPageComponent } from '../../buyer-account/invoices/parent-grouped-invoice-detail/parent-grouped-invoice-detail.component';
import { BuyerAccountOverviewComponent } from '../../buyer-account/overview/overview.component';
import { AccountSuppliersComponent } from '../../buyer-account/suppliers/suppliers.component';
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { BuyerAccountPaymentsComponent } from '../payments/payments.component';
import { RequestPayLaterPageComponent } from '../request-pay-later-page/request-pay-later-page.component';
import { BuyerInsightsAgingForecastComponent } from './insights/aging-forecast.component';
import { BuyerInsightsWorkingCapitalLiftGuard } from './insights/working-capital-lift-insights.guard';

export const routes: Routes = [
    {
        path: UiRoutes.Home,
        component: SupplyChainDirectBuyerComponent,
        data: {
            title: supplyChainDirectBuyerNode.title
        },
        children: [
            {
                path: UiRoutes.Home,
                redirectTo: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_OVERVIEW.path,
                pathMatch: 'prefix'
            },
            {
                path: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_OVERVIEW.path,
                component: BuyerAccountOverviewComponent,
                data: {
                    title: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_OVERVIEW.title
                }
            },
            {
                path: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_SUPPLIERS.path,
                component: AccountSuppliersComponent,
                data: {
                    title: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_SUPPLIERS.title
                }
            },
            {
                path: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_SUPPLIER_DETAILS.path,
                children: [
                    {
                        path:
                            supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_SUPPLIER_DETAILS
                                .children.BUYER_SUPPLIER_DETAILS.path,
                        component: SupplierDetailsComponent,
                        canActivate: [ClaimGuard],
                        data: {
                            title:
                                supplyChainDirectBuyerAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_SUPPLIER_DETAILS.children
                                    .BUYER_SUPPLIER_DETAILS.title,
                            claims:
                                supplyChainDirectBuyerAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_SUPPLIER_DETAILS.children
                                    .BUYER_SUPPLIER_DETAILS.claims
                        }
                    },
                    {
                        path: '',
                        redirectTo:
                            '/' +
                            supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_SUPPLIERS.path
                    }
                ]
            },
            {
                path:
                    supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE
                        .path,
                children: [
                    {
                        path:
                            supplyChainDirectBuyerAtlas
                                .SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE.children
                                .SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE_DETAIL.path,
                        component: AccountParentGroupedInvoiceDetailPageComponent,
                        canActivate: [ClaimGuard, FeatureFlagGuard],
                        data: {
                            title:
                                supplyChainDirectBuyerAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE.children
                                    .SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE_DETAIL.title,
                            claims:
                                supplyChainDirectBuyerAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE.children
                                    .SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE_DETAIL.claims,
                            featureFlags:
                                supplyChainDirectBuyerAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE.children
                                    .SUPPLY_CHAIN_DIRECT_BUYER_PARENT_GROUPED_INVOICE_DETAIL
                                    .featureFlags
                        }
                    },
                    {
                        path: '',
                        redirectTo:
                            '/' +
                            supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_INVOICES.path
                    }
                ]
            },
            {
                path: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_PAY_LATER.path,
                component: RequestPayLaterPageComponent,
                canActivate: [PayLaterGuard, ClaimGuard, FeatureFlagGuard],
                data: {
                    title: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_PAY_LATER.title,
                    claims: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_PAY_LATER.claims,
                    featureFlags:
                        supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_PAY_LATER.featureFlags
                }
            },
            {
                path: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_INVOICES.path,
                component: AccountInvoicesComponent,
                data: {
                    title: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_INVOICES.title
                }
            },
            {
                path: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_PAYMENTS.path,
                component: BuyerAccountPaymentsComponent,
                canActivate: [ClaimGuard],
                data: {
                    title: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_PAYMENTS.title,
                    claims: supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_PAYMENTS.claims
                }
            },
            {
                path:
                    supplyChainDirectBuyerAtlas.SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_DETAILS
                        .path,
                children: [
                    {
                        path:
                            supplyChainDirectBuyerAtlas
                                .SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_DETAILS.children
                                .EARLY_PAYMENT_DETAILS.path,
                        component: AccountPaymentDetailComponent,
                        canActivate: [ClaimGuard],
                        data: {
                            title:
                                supplyChainDirectBuyerAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_DETAILS.children
                                    .EARLY_PAYMENT_DETAILS.title,
                            claims:
                                supplyChainDirectBuyerAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_DETAILS.children
                                    .EARLY_PAYMENT_DETAILS.claims
                        }
                    },
                    {
                        path: '',
                        redirectTo:
                            '/' +
                            supplyChainDirectBuyerAtlas
                                .SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_DETAILS.path
                    }
                ]
            },
            {
                path:
                    supplyChainDirectBuyerAtlas
                        .SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_REMITTANCE_DETAILS.path,
                children: [
                    {
                        path:
                            supplyChainDirectBuyerAtlas
                                .SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_REMITTANCE_DETAILS.children
                                .EARLY_PAYMENT_REMITTANCE_DETAILS.path,
                        component: AccountPaymentDetailComponent,
                        canActivate: [ClaimGuard],
                        data: {
                            title:
                                supplyChainDirectBuyerAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_REMITTANCE_DETAILS
                                    .children.EARLY_PAYMENT_REMITTANCE_DETAILS.title,
                            claims:
                                supplyChainDirectBuyerAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_REMITTANCE_DETAILS
                                    .children.EARLY_PAYMENT_REMITTANCE_DETAILS.claims
                        }
                    },
                    {
                        path: '',
                        redirectTo:
                            '/' +
                            supplyChainDirectBuyerAtlas
                                .SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_REMITTANCE_DETAILS.path
                    }
                ]
            },
            {
                path:
                    supplyChainDirectBuyerAtlas
                        .SUPPLY_CHAIN_DIRECT_BUYER_INVOICE_TERMS_PAYMENT_DETAILS.path,
                children: [
                    {
                        path:
                            supplyChainDirectBuyerAtlas
                                .SUPPLY_CHAIN_DIRECT_BUYER_INVOICE_TERMS_PAYMENT_DETAILS.children
                                .INVOICE_TERMS_PAYMENT_DETAILS.path,
                        component: AccountPaymentDetailComponent,
                        canActivate: [ClaimGuard],
                        data: {
                            title:
                                supplyChainDirectBuyerAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_INVOICE_TERMS_PAYMENT_DETAILS
                                    .children.INVOICE_TERMS_PAYMENT_DETAILS.title,
                            claims:
                                supplyChainDirectBuyerAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_INVOICE_TERMS_PAYMENT_DETAILS
                                    .children.INVOICE_TERMS_PAYMENT_DETAILS.claims
                        }
                    },
                    {
                        path: '',
                        redirectTo:
                            '/' +
                            supplyChainDirectBuyerAtlas
                                .SUPPLY_CHAIN_DIRECT_BUYER_EARLY_PAYMENT_DETAILS.path
                    }
                ]
            },
            {
                path: supplyChainDirectBuyerInsightsNode.path,
                component: BuyerInsightsComponent,
                canActivate: [FeatureFlagGuard, BuyerInsightsGuard],
                data: {
                    title: supplyChainDirectBuyerInsightsNode.title,
                    featureFlags: supplyChainDirectBuyerInsightsNode.featureFlags
                },
                children: [
                    {
                        path:
                            supplyChainDirectBuyerInsightsAtlas
                                .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_SPEND_VOLUME.path,
                        component: BuyerInsightsSpendVolumeComponent,
                        canActivate: [FeatureFlagGuard, BuyerInsightsGuard],
                        data: {
                            title:
                                supplyChainDirectBuyerInsightsAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_SPEND_VOLUME.title,
                            featureFlags:
                                supplyChainDirectBuyerInsightsAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_SPEND_VOLUME.featureFlags
                        }
                    },
                    {
                        path:
                            supplyChainDirectBuyerInsightsAtlas
                                .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_WORKING_CAPITAL_LIFT.path,
                        component: BuyerInsightsWorkingCapitalLiftComponent,
                        canActivate: [
                            FeatureFlagGuard,
                            BuyerInsightsGuard,
                            BuyerInsightsWorkingCapitalLiftGuard
                        ],
                        data: {
                            title:
                                supplyChainDirectBuyerInsightsAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_WORKING_CAPITAL_LIFT.title,
                            featureFlags:
                                supplyChainDirectBuyerInsightsAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_WORKING_CAPITAL_LIFT
                                    .featureFlags
                        }
                    },
                    {
                        path:
                            supplyChainDirectBuyerInsightsAtlas
                                .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_EARLY_PAY_ADOPTION.path,
                        component: BuyerInsightsEarlyPayAdoptionComponent,
                        canActivate: [FeatureFlagGuard, BuyerInsightsGuard],
                        data: {
                            title:
                                supplyChainDirectBuyerInsightsAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_EARLY_PAY_ADOPTION.title,
                            featureFlags:
                                supplyChainDirectBuyerInsightsAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_EARLY_PAY_ADOPTION
                                    .featureFlags
                        }
                    },
                    {
                        path:
                            supplyChainDirectBuyerInsightsAtlas
                                .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_SUPPLIER_ENROLLMENT.path,
                        component: BuyerInsightsSupplierEnrollmentComponent,
                        canActivate: [FeatureFlagGuard, BuyerInsightsGuard],
                        data: {
                            title:
                                supplyChainDirectBuyerInsightsAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_SUPPLIER_ENROLLMENT.title,
                            featureFlags:
                                supplyChainDirectBuyerInsightsAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_SUPPLIER_ENROLLMENT
                                    .featureFlags
                        }
                    },
                    {
                        path:
                            supplyChainDirectBuyerInsightsAtlas
                                .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_AGING_FORECAST.path,
                        component: BuyerInsightsAgingForecastComponent,
                        canActivate: [FeatureFlagGuard, BuyerInsightsGuard],
                        data: {
                            title:
                                supplyChainDirectBuyerInsightsAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_AGING_FORECAST.title,
                            featureFlags:
                                supplyChainDirectBuyerInsightsAtlas
                                    .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_AGING_FORECAST.featureFlags
                        }
                    },
                    {
                        path: '**',
                        redirectTo:
                            supplyChainDirectBuyerInsightsAtlas
                                .SUPPLY_CHAIN_DIRECT_BUYER_INSIGHTS_SPEND_VOLUME.path,
                        pathMatch: 'full'
                    }
                ]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SupplyChainDirectBuyerRoutingModule {}
